// extracted by mini-css-extract-plugin
export default {"container":"footer-buttons_container__z6hVu","button":"footer-buttons_button__uIaSY","close_button":"footer-buttons_close_button__pJvHA"};